function VideoPreviewBunnynetEmbed({url}) {
    return (
        <div>
            <div dangerouslySetInnerHTML={{__html:url}}></div>
        </div>
    );
}

export default VideoPreviewBunnynetEmbed;